import React from "react";
import styles from "../styles/Footer.module.css";
import logo from "../images/fab-icon2.png";
import enamd from "../images/enamd.png";
import {
  FaInstagram,
  FaTelegram,
  FaWhatsapp,
  FaRegCopyright,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* بخش راست - اینماد و لوگو */}
        <div className={styles.footerSection}>
          <div className={styles.logoSection}>
            <img src={logo} alt="لوگو باتری100" className={styles.logo} />
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=617861&Code=1PbKhdIBc6IuPMlzA5D7R8GRuIu3XipG"
            >
              <img
                src={enamd}
                alt="نماد اعتماد الکترونیکی"
                className={styles.enamad}
              />
            </a>
          </div>
        </div>

        {/* بخش وسط - دسترسی سریع */}
        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>دسترسی سریع</h3>
          <ul className={styles.quickLinks}>
            <li>
              <a href="/محصولات/" className={styles.link}>
                محصولات
              </a>
            </li>
            <li>
              <a href="/مقالات/" className={styles.link}>
                مقالات
              </a>
            </li>
            <li>
              <a href="/تماس باما/" className={styles.link}>
                درباره ما
              </a>
            </li>
          </ul>
        </div>

        {/* بخش چپ - تماس با ما */}
        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>تماس با ما</h3>
          <div className={styles.contactInfo}>
            <p className={styles.contactItem}>موبایل: 09385912556</p>
            <p className={styles.contactItem}>ایمیل: info@battery100.ir</p>
          </div>

          <div className={styles.socialLinks}>
            <a href="#" aria-label="Instagram" className={styles.socialLink}>
              <FaInstagram className={styles.icon} />
            </a>
            <a href="#" aria-label="Telegram" className={styles.socialLink}>
              <FaTelegram className={styles.icon} />
            </a>
            <a href="#" aria-label="WhatsApp" className={styles.socialLink}>
              <FaWhatsapp className={styles.icon} />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.copyright}>
        <p className={styles.rights}>
          تمامی حقوق مادی و معنوی این سایت متعلق به باتری۱۰۰ می‌باشد
        </p>
        <p className={styles.year}>
          <FaRegCopyright className={styles.copyrightIcon} /> 1404-2025
        </p>
      </div>
    </footer>
  );
};

export default Footer;
